export const PHONE_VALIDATORS = {
  SG: /^(\+?65(\s|-)?)?\d{4}(\s|-)?\d{4}$/,
  AU: /^(?:\+?61|0)[ -]?[2-478](?:[ -]?\d){8}$/,
  US: /^(\+1\s?)?(\(?[23456789]{1}[0-9]{2}\)?)[\s-]?\d{3}[\s-]?\d{4}$/,
  CA: /^(\+1\s?)?(\(?[23456789]{1}[0-9]{2}\)?)[\s-]?\d{3}[\s-]?\d{4}$/,
  UK: /^(?:\+44[\s-]?|0)(?:\d[\s-]?){9,10}$/,
};

export const EMAIL_STRICT =
  /^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+(?:[A-Za-z]{2,}|xn--[A-Za-z0-9-]{2,})$/;

export const ORDER_NUMBER_REGEX = /^\d{9}$/;
